export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
}

export const ENDPOINTS = {
  // Auth
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    me: '/auth/me',
    refreshToken: '/auth/refresh',
    microsoft: '/auth/microsoft',
    forgotPassword: '/auth/forgot-password',
    validateResetToken: '/auth/validate-reset-token',
    resetPassword: '/auth/reset-password',
    twoFactor: {
      verify: '/auth/2fa/verify',
      resend: '/auth/2fa/resend',
      status: '/auth/2fa/status',
      setup: '/auth/2fa/setup',
      enable: '/auth/2fa/enable',
      disable: '/auth/2fa/disable',
      regenerateBackupCodes: '/auth/2fa/backup-codes/regenerate',
    },
    emailVerification: {
      verify: '/auth/verify-email',
      resend: '/auth/verify-email/resend',
    },
  },
  // Contatos comerciais da landing /para-empresas
  contacts: {
    submit: '/contacts',
    list: '/admin/contacts',
    byId: (id: string) => `/admin/contacts/${id}`,
  },
  // Coupons
  coupons: {
    validate: '/coupons/validate',
    list: '/admin/coupons',
    create: '/admin/coupons',
    byId: (id: string) => `/admin/coupons/${id}`,
  },
  // Users
  users: {
    profile: '/users/profile',
    update: '/users/profile',
    avatar: '/users/avatar',
  },
  // Modules & Episodes
  modules: {
    list: '/modules',
    byId: (id: number) => `/modules/${id}`,
  },
  episodes: {
    byId: (moduleId: number, episodeId: number) => `/episodes/${moduleId}/${episodeId}`,
  },
  // Progress
  progress: {
    user: '/progress',
    episode: (episodeId: number) => `/progress/episode/${episodeId}`,
    course: (courseId: number) => `/progress/course/${courseId}`,
    update: '/progress',
    heatmap: (year?: number) => `/progress/heatmap${year ? `?year=${year}` : ''}`,
  },
  // Exercises
  exercises: {
    byEpisode: (episodeId: number) => `/exercises/episode/${episodeId}`,
    submit: '/exercises/submit',
  },
  // Prompts (Hub)
  prompts: {
    list: '/prompts',
    create: '/prompts',
    byId: (id: string) => `/prompts/${id}`,
    like: (id: string) => `/prompts/${id}/like`,
    copy: (id: string) => `/prompts/${id}/copy`,
  },
  // Agents (Hub)
  agents: {
    list: '/agents',
    create: '/agents',
    byId: (id: string) => `/agents/${id}`,
    like: (id: string) => `/agents/${id}/like`,
  },
  // Leaderboard
  leaderboard: {
    list: '/leaderboard',
  },
  // Feedback
  feedback: {
    submit: '/feedback',
    mine: (courseId: number) => `/feedback/course/${courseId}/mine`,
  },
  // Admin
  admin: {
    metrics: '/admin/metrics',
    retention: '/admin/metrics/retention',
    downloads: '/admin/metrics/downloads',
    completion: '/admin/metrics/completion',
  },
}
